module.exports = {
      id: "comm-news-usage",
      viewBox: "0 0 223.506 38.837",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-news",
      toString: function () {
        return this.url;
      }
    }